import { ComputePercent } from "../../../../shared/scripts/number-functions";


export class ExecutiveSummaryEntry {
    Id: number;
    Group: string;
    Label: string;
    Type: number; //0: main row (no children), 1: main row (with children), 2: child row, 3: header row
    OrderBy: number;
    ParentId: number;
    Counts: number[];
    Indent: number;

    ParentHash: string; //assumes a single nesting by GROUP
    HasChildren: boolean;
    IsLastChild: boolean;

    DisplayValues: string[] = [];

    StudyColumns = [0,4,6,9,12];
    TrialColumns = [1,2,3,5,7,8,10,11,13,14];

    initialize(): void {
        if (this.Type == 3) { this.Counts = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1]; }
        else {
            const total = this.StudyColumns.reduce((acc, cv) => acc + this.Counts[cv], 0);
            this.Counts[15] = total;
        }

        //if (this.Type == 1 || 2 || 5 || 6) {
        this.DisplayValues = this.Counts.map((count: number) => count.toLocaleString() + "");
        //}

        // Take out the total for reason rows
        //if (this.Type == 5 || this.Type == 6) {
        //    this.DisplayValues[this.DisplayValues.length - 1] = "-";
        //}

        // Take out Appendix/Trial values on rows containing data for unassigned participants
        if (this.shouldSkipValue()) {
            this.TrialColumns.forEach((idx) => this.DisplayValues[idx] = '');
        }

        // Remove site values for VITAL symptom clusters
        if ([1,2].indexOf(this.Id) > -1) {
            [1,2,3].forEach((idx) => this.DisplayValues[idx] = '');
        }

    }

    createDisplayValues(parentEntry: ExecutiveSummaryEntry): void {

        this.DisplayValues = this.Counts.map((count: number, index: number) => {

            if ((this.shouldSkipValue()) && this.TrialColumns.indexOf(index) > -1) return "";
            else if (count == -1 || parentEntry.Counts[index] == -1) return "";
            else {
                let percent: number = ComputePercent(count, parentEntry.Counts[index]);
                if (percent >= 0) return count.toLocaleString() + " (" + percent.toFixed(0) + "%)";
                else return count.toLocaleString() + "";
            }
        });
    }

    shouldSkipValue() {
        return (([4, 5, 6].indexOf(this.Id) > -1) || (this.ParentId === 4) || (this.ParentId == 6));
    }


}